import {
  CategoryScale,
  type ChartData,
  Chart as ChartJS,
  type CoreChartOptions,
  type DatasetChartOptions,
  type ElementChartOptions,
  Filler,
  LinearScale,
  type LineControllerChartOptions,
  LineElement,
  type Plugin,
  type PluginChartOptions,
  PointElement,
  type ScaleChartOptions,
  Tooltip,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import type { DeepPartial } from '@interxfi/utilities/types/partial';

ChartJS.register(Filler, CategoryScale, LinearScale, PointElement, LineElement, Tooltip);

export type LineChartOptions = DeepPartial<
  CoreChartOptions<'line'> &
    ElementChartOptions<'line'> &
    PluginChartOptions<'line'> &
    DatasetChartOptions<'line'> &
    ScaleChartOptions<'line'> &
    LineControllerChartOptions
>;

interface LineChartProps<TData, TLabel> {
  data: ChartData<'line', TData, TLabel>;
  options?: LineChartOptions;
  plugins?: Plugin<'line'>[];
}

export function LineChart<TData, TLabel>({ data, options, plugins }: LineChartProps<TData, TLabel>) {
  return <Line<TData, TLabel> data={data} options={options} plugins={plugins} />;
}
